import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import $ from "jquery"

import "@tabler/core/dist/css/tabler.min.css"
import "@tabler/icons-webfont/dist/tabler-icons.min.css"
import "@tabler/core/dist/js/tabler.min.js"
import "select2/dist/css/select2"
import "select2-bootstrap-theme/dist/select2-bootstrap"
import "../stylesheets/patient_portal"

window.$ = window.jQuery = $
require("select2/dist/js/select2.full")

Rails.start()
Turbolinks.start()
ActiveStorage.start()

const patientPortalNormalRangePlugin = {
  id: "patientPortalNormalRange",
  beforeDraw: (chart, _args, options) => {
    const chartArea = chart.chartArea
    const yScale = Object.values(chart.scales).find((scale) => scale.axis === "y")
    if (!chartArea || !yScale) return

    const normalMin = finiteNumber(options.normalMin)
    const normalMax = finiteNumber(options.normalMax)
    if (normalMin === null && normalMax === null) return

    const { ctx } = chart
    const { left, right, top, bottom } = chartArea
    const clampToChart = (pixel) => Math.max(top, Math.min(bottom, pixel))
    const normalTop = normalMax === null ? top : clampToChart(yScale.getPixelForValue(normalMax))
    const normalBottom = normalMin === null ? bottom : clampToChart(yScale.getPixelForValue(normalMin))
    const fillZone = (zoneTop, zoneBottom, color) => {
      if (zoneBottom <= zoneTop) return

      ctx.fillStyle = color
      ctx.fillRect(left, zoneTop, right - left, zoneBottom - zoneTop)
    }

    ctx.save()
    ctx.beginPath()
    ctx.rect(left, top, right - left, bottom - top)
    ctx.clip()
    fillZone(top, normalTop, "rgba(214, 57, 57, 0.08)")
    fillZone(normalTop, normalBottom, "rgba(47, 179, 68, 0.10)")
    fillZone(normalBottom, bottom, "rgba(214, 57, 57, 0.08)")
    ctx.restore()
  }
}

const finiteNumber = (value) => {
  if (value === null || value === undefined || value === "") return null

  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

if (window.Chart) {
  window.Chart.register(patientPortalNormalRangePlugin)
}

const chartFilterSelector = "[data-patient-portal-chart-filter]"

const submitChartFilter = (select) => {
  if (!select.form) return

  if (select.dataset.submitTimer) {
    window.clearTimeout(Number(select.dataset.submitTimer))
  }

  select.dataset.submitTimer = window.setTimeout(() => {
    select.dataset.submitTimer = ""

    if (typeof select.form.requestSubmit === "function") {
      select.form.requestSubmit()
    } else {
      select.form.submit()
    }
  }, 350).toString()
}

const initPatientPortalChartFilters = () => {
  document.querySelectorAll(chartFilterSelector).forEach((select) => {
    const $select = $(select)
    if ($select.data("select2")) return

    $select.select2({
      allowClear: false,
      closeOnSelect: true,
      placeholder: select.dataset.placeholder || "Select a result trend",
      theme: "bootstrap",
      width: "100%"
    })

    $select.on("change.patientPortalChartFilter", () => submitChartFilter(select))
  })
}

const destroyPatientPortalChartFilters = () => {
  document.querySelectorAll(chartFilterSelector).forEach((select) => {
    const $select = $(select)

    if (select.dataset.submitTimer) {
      window.clearTimeout(Number(select.dataset.submitTimer))
      select.dataset.submitTimer = ""
    }

    $select.off(".patientPortalChartFilter")

    if ($select.data("select2")) {
      $select.select2("destroy")
    }
  })
}

document.addEventListener("turbolinks:load", initPatientPortalChartFilters)
document.addEventListener("DOMContentLoaded", initPatientPortalChartFilters)
document.addEventListener("turbolinks:before-cache", destroyPatientPortalChartFilters)
